import { useCallback, useState } from 'react';
import { useDialogStore } from '../stores/dialogStore';
import { useRequestOtp, useVerifyOtp } from './useUser';

const useOtpFlow = () => {
  const openDialog = useDialogStore((state) => state.openDialog);

  const [activeStep, setActiveStep] = useState(1);
  const [phoneNumber, setPhoneNumber] = useState('');

  // Member API
  const { mutateAsync: requestOtp, isPending: isLoadingRequestOtp } = useRequestOtp();
  const { mutateAsync: verifyOtp, isPending: isLoadingVerifyOtp } = useVerifyOtp();

  const handleRequestOtp = useCallback(
    async (phonenumber) => {
      try {
        const response = await requestOtp({ phonenumber });
        if (response.Code === '20000') {
          setActiveStep(2);
        }
      } catch (err) {
        console.error(err);
        openDialog({
          title: 'เกิดข้อผิดพลาด',
          message: 'ไม่สามารถขอ OTP ได้ในขณะนี้ \nโปรดลองใหม่อีกครั้ง',
          variant: 'error',
        });
      }
    },
    [openDialog, requestOtp]
  );

  const handleRequestOtpAgain = useCallback(async () => {
    try {
      await requestOtp({ phonenumber: phoneNumber });
    } catch (err) {
      console.error(err);
      openDialog({
        title: 'เกิดข้อผิดพลาด',
        message: 'ไม่สามารถขอ OTP ได้ในขณะนี้ \nโปรดลองใหม่อีกครั้ง',
        variant: 'error',
      });
    }
  }, [openDialog, requestOtp, phoneNumber]);

  const handleVerifyOtp = useCallback(
    async (otp) => {
      try {
        const response = await verifyOtp({ phonenumber: phoneNumber, otp_code: otp });

        if (response.Code === '20100') {
          setActiveStep(3);
        }
      } catch (err) {
        console.error(err);
        openDialog({
          title: 'เกิดข้อผิดพลาด',
          message: 'ไม่สามารถยืนยัน OTP ได้ในขณะนี้ \nโปรดลองใหม่อีกครั้ง',
          variant: 'error',
        });
      }
    },
    [openDialog, verifyOtp, phoneNumber]
  );

  const handleChangeStep = useCallback((step) => {
    setActiveStep(step);
  }, []);

  return {
    activeStep,
    setActiveStep,
    phoneNumber,
    setPhoneNumber,
    isLoadingRequestOtp,
    isLoadingVerifyOtp,
    handleRequestOtp,
    handleRequestOtpAgain,
    handleVerifyOtp,
    handleChangeStep,
  };
};

export default useOtpFlow;
